import React from 'react';
import InteractiveImage from './components/InteractiveImage';

const App: React.FC = () => {
  const points = [
    {
      id: 'bandages',
      x: 10,  // 25% from the left edge
      y: 90,  // 30% from the top
      label: 'Bandages (18)',
      description: 'Various sizes of sterile adhesive bandages for minor cuts, scrapes, and bruises.'
    },
    {
      id: 'bandages2',
      x: 70,  // 25% from the left edge
      y: 80,  // 30% from the top
      label: 'Bandages (18)',
      description: 'Various sizes of sterile adhesive bandages for minor cuts, scrapes, and bruises.'
    },
    {
      id: 'instructions',
      x: 25,
      y: 40,
      label: 'Instructions (1)',
      description: 'Instructions on how to use the first aid kit.'
    },
    {
      id: 'gauze',
      x: 65,  // 65% from the left edge
      y: 25,  // 25% from the top
      label: 'Gauze Pads (10)',
      description: 'Protects and covers cuts and wounds.'
    },
    {
      id: 'wipes',
      x: 45,  // 40% from the left edge
      y: 25,  // 60% from the top
      label: 'Alcohol Wipes (10)',
      description: 'Cleans and disinfects wounds.'
    },
    {
      id: 'crayons',
      x: 80,  // 80% from the left edge
      y: 55,  // 55% from the top
      label: 'Crayons (4)',
      description: 'A comforting distraction for children.'
    },
    {
      id: 'antibiotic',
      x: 40,
      y: 85,
      label: 'Antibiotic Ointment (4)',
      description: 'Prevents infection and speeds healing.'
    }
  ];

  return (
    <div style={{ 
      maxWidth: '1000px', 
      margin: '0 auto', 
      padding: '40px 20px',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      border: '2px solid rgba(96, 165, 250, 0.5)',
      borderRadius: '12px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(96, 165, 250, 0.2), 0 0 30px -5px rgba(96, 165, 250, 0.3)',
      backgroundColor: 'white'
    }}>
      <h1 style={{
        fontSize: '28px',
        fontWeight: '600',
        color: '#1f2937',
        marginBottom: '24px',
        textAlign: 'center',
        letterSpacing: '-0.02em',
        paddingBottom: '20px',
        borderBottom: '1px solid #e5e7eb'
      }}>
        First Aid Kit Contents
      </h1>
      <InteractiveImage
        imageUrl="/images/first-aid-kit.png"
        points={points}
        width="100%"
      />
    </div>
  );
};

export default App;
